var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('logged-in-layout',[(_vm.ready)?_c('main',[_c('h1',[_vm._v("SMS")]),_vm._v(" "),(_vm.customer)?_c('contact',{attrs:{"name":_vm.customer.name,"photoUrl":_vm.customer.photoUrl,"phoneNumber":_vm.phoneNumber,"contact":_vm.contact}}):_vm._e(),_vm._v(" "),_c('sms-window',{attrs:{"recipient":_vm.phoneNumber.number,"prospectId":_vm.prospectId,"objectType":_vm.objectType,"deviceId":_vm.deviceId}})],1):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-513535d4","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/sms/sms.vue
// module id = hyTq
// module chunks = 1